import { render, staticRenderFns } from "./TrainingsAnsweringPage.vue?vue&type=template&id=40aa5cbf&scoped=true"
import script from "./TrainingsAnsweringPage.vue?vue&type=script&lang=js"
export * from "./TrainingsAnsweringPage.vue?vue&type=script&lang=js"
import style0 from "./TrainingsAnsweringPage.vue?vue&type=style&index=0&id=40aa5cbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40aa5cbf",
  null
  
)

export default component.exports